import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Alert, Box, Button, GlobalStyles, Stack, Typography } from '@mui/material';
import { canReturnToAdmin, endActorSupport, supportSession } from '../../api/actorSupport';

export default function ActorSupportBanner() {
  const session = supportSession();
  const token = session?.access_token;
  const banner = useRef(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [now, setNow] = useState(Date.now());
  useLayoutEffect(() => {
    if (!token || !banner.current) return undefined;
    const measure = () => document.documentElement.style.setProperty('--actor-support-height', `${banner.current?.getBoundingClientRect().height || 0}px`);
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(banner.current);
    return () => { observer?.disconnect(); document.documentElement.style.removeProperty('--actor-support-height'); };
  }, [token]);
  useEffect(() => {
    if (!token) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [token]);
  if (!session) return null;
  const remaining = Math.max(0, Math.ceil((Date.parse(session.expires_at) - now) / 60000));
  const finish = async () => {
    setBusy(true);
    try { await endActorSupport(); } catch (err) { setError(err.message); setBusy(false); }
  };
  return <Box ref={banner} sx={{ position: 'sticky', top: 0, zIndex: 1600 }}>
    <GlobalStyles styles={{
      '.MuiAppBar-positionSticky': { top: 'var(--actor-support-height, 0px)' },
      '.sidebar': { top: 'var(--actor-support-height, 0px)', height: 'calc(100vh - var(--actor-support-height, 0px))' },
    }} />
    <Alert severity="warning" role="status">
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
        <Typography>Support-Modus (nur lesen): angemeldet als {session.target_email}. {remaining ? `Noch ${remaining} Min.` : 'Sitzung abgelaufen.'} Zugriffe werden protokolliert.</Typography>
        <Button variant="outlined" color="inherit" disabled={busy} onClick={finish}>{canReturnToAdmin() ? 'Zurück zum Admin' : 'Support-Modus beenden'}</Button>
      </Stack>
    </Alert>
    {error && <Alert severity="error">{error}</Alert>}
  </Box>;
}
